import React, { useEffect, useState } from "react"
import { useStore } from "../teafuljs/store"
import { getDocument } from "../apis/firebase"
import { get, set, del } from "idb-keyval"
import scrollToElement from "scroll-to-element"
import Introduction2 from "../components/Introduction2/Introduction2"
import BibleText from "../components/BibleText/BibleText"
import SegmentData from "../components/SegmentData/SegmentData"
import ReadTogether from "../../static/images/SVB-Read-together.png"
import DiscussTogether from "../../static/images/SVB-Discuss-together.png"
import QuestionsRefs from "../data/newQuestionRefs.json"
import Button from "@material-ui/core/Button"
import VerbViewDialog from "../components/Dialogs/VerbViewDialog"
import SourceViewDialog from "../components/Dialogs/SourceViewDialog"
import SphereViewDialog from "../components/Dialogs/SphereViewDialog"
import GAPDialog from "../components/Dialogs/GAPDialog"
import ValuesDialog from "../components/Dialogs/ValuesDialog"
import InterlinearDialog from "../components/Dialogs/InterlinearDialog"
import OTNTData from "../components/SegmentData/OTNTData"
import Divider from "@material-ui/core/Divider"
import Typography from "@material-ui/core/Typography"
import CheckCircle from "@material-ui/icons/CheckCircle"
import CheckCircleOutlined from "@material-ui/icons/CheckCircleOutlined"
import LoadingSpinner from "../components/LoadingSpinner/LoadingSpinner"
import BibleBookList from "../data/BookChapterList.json"
import { getTranslation } from "../scripts/getTranslation"
import Questions from "../components/Questions/Questions"
import { recordEvent, initGA } from "../../src/apis/googleAnalytics"
import GetSegment from "../scripts/NavigateToSegment"
import getBookOfSegment from "../scripts/getBookOfSegment"
import "../../static/global.css"
import { validateVersion, validateSegment } from '../scripts/validateVersion'
import { getAvailableSegment } from "../scripts/getAvailableSegment"
import CheckMark from '../components/CheckMark'
import { checkReadMark } from "../scripts/checkReadMark"

import { makeStyles } from "@material-ui/core/styles"

initGA()
const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    fontSize: "100%",
  },
  displayedContent: {
    width: "100%",
  },
  typography: {
    padding: theme.spacing(2),
    fontSize: "small",
    color: "white",
  },
  paper: {
    background: "#3A4C7D",
    width: "75vw",
  },
  segmentDataContainer: {
    display: "flex",
    justifyContent: "center",
    margin: "10px 0",
    padding: "10px 0",
  },
  header: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    paddingTop: "5px",
  },
  title: {
    fontSize: "110%",
    fontWeight: " bold",
    textDecoration: "underline",
    textTransform: "uppercase",
    width: "100%",
    margin: 0,
    textAlign: "center",
    lineHeight: 1.2,
  },
  reference: {
    margin: 0,
    fontSize: "60%",
    color: "grey",
  },
  discuss: {
    display: "block",
    textAlign: "center",
    margin: "10px 0",
    padding: "10px 0",
    borderTop: "0.25px lightgrey solid",
  },
  footer: {
    textAlign: "center",
    fontSize: "60%",
    margin: "10px 0 30px 0",
    "& p": {
      margin: 0,
    },
    whiteSpace: "pre-wrap",
  },
  images: {
    width: "100%",
    margin: "10px auto 0 auto",
    textAlign: "center",
    justifyContent: "center",
  },
  readImage: {
    marginBottom: "20px",
  },
  content: {
    margin: "0 0 10px 0",
    padding: "0 0 10px 0",
  },
  questions: {
    textAlign: "left",
    margin: "30px 0",
    "& p": {
      margin: "10px 0",
    },
  },
  imgCaption: {
    width: "100%",
    color: "grey",
    fontSize: "70%",
    margin: "-20px 0 0 0",
    textAlign: "center",
  },
  groupIcons: {
    width: "200px",
    opacity: 0.6,
  },
  furtherDiscovery: {
    textAlign: "center",
    margin: "10px",
  },
  checkmarkdiv: {
    position: "relative",
    width: "75px",
    height: '75px',
    display: "flex",
    justifyContent: "center",
    margin: "20px auto",
  },
  checkmark: {
    width: "75px",
    height: "75px",
  },
  loader: {
    position: "relative",
    width: "100%",
    textAlign: "center",
  },
  psalmTitleDiv: {
    display: "flex",
    flexDirection: "column",
    position: "relative",
    width: "100%",
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "120%",
    fontStyle: "italic",
    paddingTop: "20px",
  },
  psalmTitle: {
    margin: 0,
  },
  error: {
    color: "red",
    textAlign: "center",
  },
}))

export default props => {
  const [readPlan, setReadPlan, resetReadPlan] = useStore.readPlan();
  const [readPlanID, setReadPlanID, resetReadPlanID] = useStore.readPlanID();
  const [searchID, setSearchID] = useStore.searchID();
  const [interlinear, setInterlinear] = useStore.interlinear();
  const [showSpheres, setShowSpheres] = useStore.showSpheres()
  const [showGAPPopup, setShowGAPPopup] = useStore.showGAPPopup()
  const [showVerbs, setShowVerbs] = useStore.showVerbs()
  const [showValues, setShowValues] = useStore.showValues()
  const [currentSegmentID, setCurrentSegmentID] = useStore.currentSegmentID()
  const [currentBook, setCurrentBook] = useStore.currentBook()
  const [refID, setRefID] = useStore.refID()
  const [language, setLanguage] = useStore.language();
  const [version, setVersion] = useStore.version()
  const translations = useStore.translations()[0]
  const AvailableContent = useStore.AvailableContent()[0]
  const displayRef = useStore.displayRef()[0]
  const showQA = useStore.showQA()[0]
  const [showGAP, setShowGAP] = useStore.showGAP()
  const versification = useStore.versification()[0]
  const [history, setHistory] = useStore.history()

  const classes = useStyles()
  const [gettingSegment, updateGettingSegment] = useState(false)
  const [displayedSegment, updateDisplayedSegment] = useState(false)
  const [questionRef, updateQuestionRef] = useState(false)
  const [loading, updateLoading] = useState(true)
  const rpKey = readPlan
    ? readPlan[
        `readingPlan-${language}-${version}-${
          currentSegmentID
        }`
      ]
    : null
  const [read, updateRead] = useState(rpKey)

  const currentSegment =
    displayedSegment && !displayedSegment.error
      ? displayedSegment.id.split("-")[
          displayedSegment.id.split("-").length - 1
        ]
      : ""

  async function getSegmentFromIDB(language, version, segment) {
    let chosenSegment = segment
    if (!validateSegment(AvailableContent, language, version, segment)) {
      const newSegment = getAvailableSegment(
        AvailableContent,
        language,
        version
      )
      console.log(segment, newSegment)
      chosenSegment = newSegment
      setCurrentSegmentID(newSegment)
    }
      if (!gettingSegment) {
        updateGettingSegment(true)
      }
    await get(`${language}-${version}-${chosenSegment}`)
      .then(async val => {
        if (val === undefined) {
          getDocument(`languages/${language}/${version}/${chosenSegment}`)
            .then(async response => {
              updateAppropriateContext(response.data())
            })
            .catch(error => {
              updateGettingSegment(false)
              updateDisplayedSegment({
                error: "There was an error",
                id: `${language}-${version}-${chosenSegment}`,
              })
              console.log(error)
            })
        } else {
          if (val) {
            if (!val.version) {
              alert(
                `There's a new update for your version, please go to the menu and DOWNLOAD THIS VERSION again.`
              )
            }
            updateAppropriateContext(val)
          } else {
            getDocument(`languages/${language}/${version}/${chosenSegment}`)
              .then(async response => {
                updateAppropriateContext(response.data())
              })
              .catch(error => console.log(error))
          }
        }
      })
      .catch(async e => {
        getDocument(`languages/${language}/${version}/${chosenSegment}`)
          .then(async response => {
            updateAppropriateContext(response.data())
          })
          .catch(error => console.log(error))
      })
    updateLoading(false)
    if (gettingSegment) {
      updateGettingSegment(false)
    }
  }

  function updateAppropriateContext(response) {
    const split = response.id.split("-")
    if (split[split.length - 1][0] !== "I") {
      updateQuestionRef(QuestionsRefs[split[split.length - 1]].QRef1)
    }
    if (response.id !== displayedSegment.id) {
      updateDisplayedSegment(response)
    }
    updateLoading(false)
    updateGettingSegment(false)
  }

  const getSegmentAfterValidation = () => {
    if (validateVersion(AvailableContent, language, version)) {
      if (validateSegment(AvailableContent, language, version, currentSegmentID)) {
        console.log(
          "getSegmentAfterValidation: getting original segment",
          currentSegmentID
        )
        getSegmentFromIDB(language, version, currentSegmentID)
      } else {
        const newSeg = getAvailableSegment(AvailableContent, language, version)
        console.log(
          "getSegmentAfterValidation: getting new segment",
          newSeg
        )
        getSegmentFromIDB(language, version, newSeg)
      }
    } else {
      console.log("getSegmentAfterValidation: getting ENG-NLT-S001 segment")
      setLanguage("ENG");
      setVersion("NLT");
      getSegmentFromIDB("ENG", "NLT", "S001")
    }
  }

  // rebuild all the content for the Reader using the new script
  // adding versionID info to each segment to update reader page appropriately
  // create a single check !== `${displayedSegment.versionID}-${displayedSegment.id}`
  function checkNeedToUpdate() {
    if (AvailableContent) {
      if (!displayedSegment && !gettingSegment) {
        if (props.location.hash.split("-").length > 3) {
          addFeaturesFromHash()
        }
        getSegmentAfterValidation()
      } else if (!loading && !gettingSegment) {
        if (
          !displayedSegment ||
          `${language}-${version}-${currentSegmentID}` !==
            displayedSegment.id
        ) {
          if (props.location.hash.length > 14) {
            addFeaturesFromHash()
          }
          if (
            displayedSegment.error &&
            displayedSegment.id !==
              `${language}-${version}-${currentSegmentID}`
          ) {
            updateLoading(true)
            // getSegmentAfterValidation()
            getSegmentFromIDB(language, version, currentSegmentID)
          } else if (!displayedSegment.error) {
            updateLoading(true)
            getSegmentFromIDB(language, version, currentSegmentID)
            // getSegmentAfterValidation()
          }
        }
      }
    }
  }

  function addFeaturesFromHash() {
    console.log("props.location", props.location)
    const hashRefs = props.location.hash.split("-")
    if (hashRefs.length > 3) {
      const book =
        Object.keys(BibleBookList).indexOf(hashRefs[3]) !== -1
          ? hashRefs[3]
          : null
      const chapter =
        BibleBookList[book].chapters.split(",").indexOf(hashRefs[4]) !== -1
          ? hashRefs[4]
          : null
      const verse = Number.isInteger(parseInt(hashRefs[5])) ? hashRefs[5] : null
      const layer =
        ["interlinear", "verbs", "spheres"].indexOf(hashRefs[6]) !== -1
          ? hashRefs[6]
          : null
      if (!book || !chapter || !verse) {
        return
      }
      const refID = `${hashRefs[3]}-${hashRefs[4]}-${hashRefs[5]}`
      setSearchID(refID)
      if (layer === "interlinear") {
        setInterlinear(true)
        setShowVerbs(false)
        setShowSpheres(false)
        setShowGAP(false)
        setShowValues(false)
      } else if (layer === "verbs") {
        setInterlinear(false)
        setShowVerbs(true)
        setShowSpheres(false)
        setShowGAP(false)
        setShowValues(false)
      } else if (layer === "spheres") {
        setInterlinear(false)
        setShowVerbs(false)
        setShowSpheres(true)
        setShowGAP(false)
        setShowValues(false)
      } else if (layer === "values") {
        setInterlinear(false)
        setShowVerbs(false)
        setShowSpheres(false)
        setShowGAP(false)
        setShowValues(true)
      } else if (layer === "GAP") {
        setInterlinear(false)
        setShowVerbs(false)
        setShowSpheres(true)
        setShowGAP(false)
        setShowValues(false)
      }
    }
  }

  checkNeedToUpdate()

  // This controls the popup for the Verb information
  const [verbDialog, updateVerbDialog] = useState({ open: false, content: {} })
  const newVerbDialog = obj => {
    updateVerbDialog(obj)
  }

  // This controls the popup for the SourceView information
  const [sourceViewDialog, updateSourceViewDialog] = useState({
    open: false,
    content: {},
  })
  const newSourceViewDialog = obj => {
    updateSourceViewDialog(obj)
  }

  // This controls the popup for the Interlinear information
  const [interlinearDialog, updateInterlinearDialog] = useState({
    open: false,
    content: {},
  })
  const newInterlinearDialog = obj => {
    updateInterlinearDialog(obj)
  }

  // This controls the popup for the SphereView information
  const [sphereViewDialog, updateSphereViewDialog] = useState({
    open: false,
    content: {},
  })
  const newSphereViewDialog = obj => {
    updateSphereViewDialog(obj)
  }
  // This controls the popup for the GAP information
  // const [GAPDialog, updateGAPDialog] = useState({
  //   open: false,
  //   content: {},
  // })
  // const newGAPDialog = obj => {
  //   updateGAPDialog(obj)
  // }
  // This controls the popup for the Values information
  const [valuesDialog, updateValuesDialog] = useState({
    open: false,
    content: {},
  })
  const newValuesDialog = obj => {
    updateValuesDialog(obj)
  }

  function handleClose(view) {
    if (view === "verbView") {
      newVerbDialog({ open: false, content: {} })
    } else if (view === "sphereView") {
      newSphereViewDialog({ open: false, content: {} })
    // } else if (view === "GAP") {
    //   setShowGAPPopup(false)
      // newGAPDialog({ open: false, content: {} })
    } else if (view === "valuesView") {
      newValuesDialog({ open: false, content: {} })
    } else if (view === "sourceView") {
      newSourceViewDialog({ open: false, content: {} })
    } else if (view === "interlinearView") {
      newInterlinearDialog({ open: false, content: {} })
    }
  }

  const navigateToRef = (obj, callback) => {
    setHistory([
      {
        page: window.location.pathname,
        language: language,
        version: version,
        segment: currentSegmentID,
        scrollY: window.scrollY,
      },
      ...history,
    ])
    const segment = GetSegment(obj.book, obj.chapter, obj.verse)
    if (currentSegmentID === segment) {
      const elements = Array.from(
        document.querySelectorAll(
          `[verseref=ref-${obj.book}-${obj.chapter}-${obj.verse}]`
        )
      )
      const element = elements.find(
        el =>
          !el.getAttribute("data-verse") &&
          !(
            el.getAttribute("style") &&
            el.getAttribute("style").includes("display: none")
          )
      )
      scrollToElement(element, {
        offset: -65,
        ease: "inOutCube",
        duration: 1500,
      })
      callback()
    } else {
      setCurrentSegmentID(segment)
      setCurrentBook(obj.book)
      setRefID("")
      setSearchID(`${obj.book}-${obj.chapter}-${obj.verse}`)
      callback()
    }
  }

  useEffect(() => {
    console.log("reader.js useEffect", gettingSegment)
    if (typeof window !== undefined) {
      if (
        !currentBook ||
        getBookOfSegment(
          currentSegment,
          AvailableContent,
          language,
          version
        ) !== currentBook
      ) {
        setCurrentBook(
          getBookOfSegment(currentSegment, AvailableContent, language, version)
        )
      }

      // logic for gettingSegment (dependency)
      if (!gettingSegment) {
        console.log("!gettingSegment", window.scrollY, searchID)
        if (
          Number.isInteger(searchID) &&
          (searchID > 0 || (searchID === 0 && window.scrollY !== 0))
        ) {
          console.log('scrolling #1')
          window.scrollTo(0, searchID)
          setSearchID("")
        } else if (searchID !== "") {
          const elements = Array.from(
            document.querySelectorAll(`[verseref=ref-${searchID}]`)
          )
          const element = elements.find(
            el =>
              !el.getAttribute("data-verse") &&
              !(
                el.getAttribute("style") &&
                el.getAttribute("style").includes("display: none")
              )
          )
          console.log("scrolling #2")
          scrollToElement(element, {
            offset: -65,
            ease: "inOutCube",
            duration: 1500,
          })
          setSearchID("")
        } else if (refID !== "top" && refID !== "") {
          const elements = document.querySelectorAll(
            `[verseref=ref-${refID}]`
          )
          const element = [...elements].find(
            el =>
              !el.getAttribute("data-verse") &&
              !(
                el.getAttribute("style") &&
                el.getAttribute("style").includes("display: none")
              )
          )
          console.log("scrolling #3")
          scrollToElement(element, {
            offset: -65,
            ease: "inOutCube",
            duration: 1500,
          })
          setSearchID("")
        } else if (refID === "top") {
          console.log("scrolling to TOP")
          scrollToElement("#topOfPage", {
            offset: -65,
            // ease: "inOutCube",
            duration: 0,
          })
        }
      }
      // if gettingSegment is TRUE
      else {
        console.log('getting segment...')
      }
    }
    if (rpKey) {
      updateRead(rpKey)
    }
    checkNeedToUpdate()
  }, [gettingSegment])

  function changeQuestions() {
    const questionRefs = [
      QuestionsRefs[currentSegment].QRef1,
      QuestionsRefs[currentSegment].QRef2,
      QuestionsRefs[currentSegment].QRef3,
    ]
    const index = questionRefs.indexOf(questionRef)
    if (index === 0) {
      recordEvent(
        "Change Questions",
        `${language}-${version}`,
        currentSegmentID
      )
      const nextRef = QuestionsRefs[currentSegment].QRef2
      updateQuestionRef(nextRef)
    }
    if (index === 1) {
      recordEvent(
        "Change Questions",
        `${language}-${version}`,
        currentSegmentID
      )
      const nextRef = QuestionsRefs[currentSegment].QRef3
      updateQuestionRef(nextRef)
    }
    if (index === 2) {
      recordEvent(
        "Change Questions",
        `${language}-${version}`,
        currentSegmentID
      )
      const nextRef = QuestionsRefs[currentSegment].QRef1
      updateQuestionRef(nextRef)
    }
  }

  // function checkReadPlanMark(segment) {
  //   if (
  //     readPlan[`readingPlan-${language}-${version}-${segment}`] ===
  //     true
  //   ) {
  //     const newReadObj = Object.assign(readPlan, {
  //       [`readingPlan-${language}-${version}-${segment}`]: false,
  //     })
  //     setReadPlan(newReadObj)
  //     setReadPlanID(readPlanID + 1)
  //   } else {
  //     const newReadObj = Object.assign(readPlan, {
  //       [`readingPlan-${language}-${version}-${segment}`]: true,
  //     })
  //     setReadPlan(newReadObj)
  //     setReadPlanID(readPlanID + 1)
  //   }
  // }

  // function checkReadMark() {
  //   const rpKey = `readingPlan-${language}-${version}-${
  //     currentSegmentID
  //   }`
  //   if (read) {
  //     del(rpKey)
  //     checkReadPlanMark(currentSegmentID)
  //     updateRead(false)
  //   } else {
  //     recordEvent(
  //       "Read Segment",
  //       `${language}-${version}`,
  //       `${currentSegmentID}`
  //     )
  //     set(rpKey, true)
  //     checkReadPlanMark(currentSegmentID)
  //     updateRead(true)
  //   }
  // }

  const getTranslationHelper = (type, ref, key) => {
    return getTranslation(translations, language, type, ref, key)
  }

  const currentYear = new Date().getFullYear()

  const isLoading = loading && !displayedSegment
  if (typeof window !== "undefined") {
    window.location.hash = `${language}-${version}-${currentSegmentID}`
  }
  return (
    <div className={classes.root} id="topOfPage">
      {isLoading || !AvailableContent.content || gettingSegment ? (
        <div className={classes.loader}>
          <LoadingSpinner />
        </div>
      ) : (
        <div className={classes.displayedContent}>
          <div className={classes.header}>
            <p className={classes.title}>
              {getTranslation(
                translations,
                language,
                "Titles",
                currentSegmentID
              )}
            </p>
          </div>
          {displayedSegment && displayedSegment.error && (
            <p className={classes.error}>{displayedSegment.error}</p>
          )}
          {currentSegment && currentSegment[0] === "S" ? (
            <div>
              {!!displayedSegment.colors &&
                !!displayedSegment.sources &&
                !!displayedSegment.repeatedWords.length && (
                  <div className={classes.segmentDataContainer}>
                    <SegmentData
                      translations={translations}
                      language={language}
                      currentBook={currentBook}
                      colors={displayedSegment.colors}
                      sources={displayedSegment.sources}
                      repeatedWords={displayedSegment.repeatedWords}
                    />
                  </div>
                )}
              <div className={`${classes.images} ${classes.readImage}`}>
                <img
                  src={ReadTogether}
                  className={classes.groupIcons}
                  alt="Read Together"
                />
                <p className={classes.imgCaption}>
                  {getTranslation(
                    translations,
                    language,
                    "UI",
                    "read_color_icon_caption"
                  )}
                </p>
                <Divider width={200} style={{ margin: "0 auto" }} />
              </div>
              {AvailableContent.version === 2 ? (
                <BibleText
                  className={classes.content}
                  content={displayedSegment.content}
                  verbViewDialog={newVerbDialog}
                  newSourceViewDialog={newSourceViewDialog}
                  newInterlinearDialog={newInterlinearDialog}
                  newSphereViewDialog={newSphereViewDialog}
                  // newGAPDialog={newGAPDialog}
                  newValuesDialog={newValuesDialog}
                  language={language}
                  version={version}
                  versification={versification}
                  showSpheres={showSpheres}
                  showValues={showValues}
                  versificationType={
                    AvailableContent.content[language].versions[version]
                      .versification
                  }
                  availableBooks={Object.keys(
                    AvailableContent.content[language][version]
                  )}
                  navigateToRef={navigateToRef}
                  translate={getTranslationHelper}
                  displayRef={displayRef}
                  showQA={showQA}
                  showGAP={showGAP && +currentSegment.substring(1, 4) > 265}
                />
              ) : null}
              {verbDialog.open === true ? (
                <VerbViewDialog
                  verbDialog={verbDialog}
                  newVerbDialog={newVerbDialog}
                  onClose={() => handleClose("verbView")}
                />
              ) : null}
              {sourceViewDialog.open === true ? (
                <SourceViewDialog
                  sourceViewDialog={sourceViewDialog}
                  newSourceViewDialog={newSourceViewDialog}
                  onClose={() => handleClose("sourceView")}
                />
              ) : null}
              {sphereViewDialog.open === true ? (
                <SphereViewDialog
                  sphereViewDialog={sphereViewDialog}
                  newSphereViewDialog={newSphereViewDialog}
                  onClose={() => handleClose("sphereView")}
                />
              ) : null}
              {console.log("showGAPPopup", showGAPPopup)}
              {showGAPPopup ? (
                <GAPDialog
                  open={showGAPPopup}
                  introID={1}
                  onClose={() => setShowGAPPopup(false)}
                />
              ) : null}
              {valuesDialog.open === true ? (
                <ValuesDialog
                  valuesDialog={valuesDialog}
                  newValuesDialog={newValuesDialog}
                  onClose={() => handleClose("valuesView")}
                />
              ) : null}
              {interlinearDialog.open === true ? (
                <InterlinearDialog
                  interlinearDialog={interlinearDialog}
                  newInterlinearDialog={newInterlinearDialog}
                  language={language}
                  version={version}
                  onClose={() => handleClose("interlinearView")}
                />
              ) : null}
              <div className={classes.discuss}>
                <div className={classes.images}>
                  <img
                    src={DiscussTogether}
                    alt="Discuss Together"
                    className={classes.groupIcons}
                    style={{ opacity: 1 }}
                  />
                  <p
                    className={classes.imgCaption}
                    style={language === "ARB" ? { direction: "rtl" } : {}}
                  >
                    {getTranslation(
                      translations,
                      language,
                      "UI",
                      "discuss_icon_caption"
                    )}
                  </p>
                </div>
                <p
                  className={classes.title}
                  style={
                    language === "ARB"
                      ? { direction: "rtl", marginTop: 30 }
                      : { marginTop: 30 }
                  }
                >
                  {getTranslation(
                    translations,
                    language,
                    "Questions",
                    questionRef.split("-")[0]
                  )}
                </p>
                <div
                  className={classes.questions}
                  style={
                    language === "ARB"
                      ? { direction: "rtl", textAlign: "right" }
                      : {}
                  }
                >
                  <Questions
                    translations={translations}
                    language={language}
                    questionRef={questionRef}
                  />
                </div>
                <Button
                  color="secondary"
                  variant="outlined"
                  onClick={() => changeQuestions()}
                  style={language === "ARB" ? { direction: "rtl" } : {}}
                >
                  {getTranslation(
                    translations,
                    language,
                    "UI",
                    "change_questions_button"
                  )}
                </Button>
              </div>
              <div className={classes.checkmarkdiv}>
                <CheckMark
                  language={language}
                  version={version}
                  id={currentSegmentID}
                />
              </div>
              <Divider />
              <div className={classes.furtherDiscovery}>
                <Typography variant="h4">
                  {getTranslation(
                    translations,
                    language,
                    "UI",
                    "further_discovery"
                  )}
                </Typography>
                <OTNTData
                  translations={translations}
                  language={language}
                  segmentID={currentSegment}
                />
              </div>
              <div className={classes.footer}>
                {(() => {
                  const copyright =
                    AvailableContent.content[language].versions[version]
                      .copyright
                  if (copyright && copyright.includes("Biblica")) {
                    return (
                      <a
                        href="https://biblica.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: "inherit",
                          textDecoration: "underline",
                        }}
                      >
                        {copyright}
                      </a>
                    )
                  } else {
                    return <p>{copyright}</p>
                  }
                })()}
                <br />
                <p>© 2010, 2016, 2018, {currentYear} SourceView LLC.</p>
              </div>
            </div>
          ) : (
            <div>
              {AvailableContent.version === 2 &&
              currentSegment &&
              !displayedSegment.error ? (
                <Introduction2
                  content={displayedSegment.content}
                  bookData={
                    displayedSegment.colors
                      ? {
                          colors: displayedSegment.colors,
                          sources: displayedSegment.sources,
                        }
                      : null
                  }
                  segmentID={currentSegmentID}
                  book={currentBook}
                  alignment={language === "ARB" || language === "HBO"}
                  language={language}
                  version={version}
                />
              ) : null}
              {validateVersion(AvailableContent, language, version) ? (
                <div className={classes.footer}>
                  {(() => {
                    const copyright =
                      AvailableContent.content[language].versions[version]
                        .copyright
                    if (copyright && copyright.includes("Biblica")) {
                      return (
                        <a
                          href="https://biblica.com"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: "inherit",
                            textDecoration: "underline",
                          }}
                        >
                          {copyright}
                        </a>
                      )
                    } else {
                      return (
                        <p
                          style={language === "ARB" ? { direction: "rtl" } : {}}
                        >
                          {copyright}
                        </p>
                      )
                    }
                  })()}
                  <br />
                  <p>© 2010, 2016, 2018, {currentYear} SourceView LLC.</p>
                </div>
              ) : null}
            </div>
          )}
        </div>
      )}
    </div>
  )
}
